import useSWRMutation from 'swr/mutation';
import baseFetcher from '../../shared/baseFetcher';
import usePrequal from '../usePrequal';
import { KEY } from '../constants';

const updatePrequalFetcher = (config, { arg }, prequalId, timeout) => baseFetcher({
  ...config,
  url: `/prequals/${prequalId}`,
  method: 'PATCH',
  data: arg,
  timeout,
});

const usePrequalUpdate = (timeout) => {
  const { data: prequal } = usePrequal();
  return useSWRMutation(KEY, (...args) => updatePrequalFetcher(...args, prequal.id, timeout), {
    populateCache: true,
    revalidate: false,
  });
};

export default usePrequalUpdate;
